// src/design/layers.ts
var e = "z-[calc(var(--z-index-modal)+var(--layer-index,0))]";
export { e as MODAL_LAYER };

//# sourceMappingURL=layers.js.map